import MobileLeaderboardCard from "./_components/mobile-leaderboard-card";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";

type LeaderBoardProps = {
  loading: boolean;
  overviewRange: "MTD" | "WTD" | "YTD";
  gtgOnly: boolean;
  primaryUserGroup: string;
};

export default function LeaderBoard({
  loading,
  overviewRange,
  gtgOnly,
  primaryUserGroup,
}: LeaderBoardProps) {
  return (
    <Card>
      <CardHeader className="pb-2">
        <CardTitle className="text-sm font-semibold">Leaderboard</CardTitle>
      </CardHeader>
      <CardContent>
        <MobileLeaderboardCard
          loading={loading}
          overviewRange={overviewRange}
          gtgOnly={gtgOnly}
          primaryUserGroup={primaryUserGroup}
        />
      </CardContent>
    </Card>
  );
}
